module.exports = __webpack_public_path__ + "img/help_authentication@3x.d2e3db93.png";